import { selectUser } from 'containers/Login/loginSlice'
import ActionsButton from 'components/ActionsButton'
import useTranslation from 'hooks/useTranslation'
import { ACCOUNT_TYPE } from '../accountSlice'
import { useHistory } from 'react-router-dom'
import { displayPrice } from 'utils/string'
import { useSelector } from 'react-redux'

const Actions = () => {
  const user = useSelector(selectUser)
  const userHasUnpaidInvoices = Array.isArray(user?.unpaid_invoices) && user.unpaid_invoices.length > 0

  const { push } = useHistory()
  const { t } = useTranslation('account')
  const goTo = route => push(`/account/${route}`)

  return (
    <div className='actionsButton__buttons'>
      <div className='buttons__row center'>
        <ActionsButton
          Icon='user'
          text={t('yourData')}
          action={() => goTo(ACCOUNT_TYPE.basic)} />
        <hr />
        <ActionsButton
          Icon='company'
          text={t('companies')}
          action={() => goTo(ACCOUNT_TYPE.company)} />
        <hr />
        <ActionsButton
          Icon='invoices'
          text={t('invoices')}
          additionalText={userHasUnpaidInvoices ? `${user.unpaid_invoices.length}` : undefined}
          action={() => goTo(ACCOUNT_TYPE.invoices)} />
      </div>

      <hr />

      <div className='buttons__row center'>
        <ActionsButton
          Icon='share'
          text={t('shares')}
          action={() => goTo(ACCOUNT_TYPE.share)} />
        <hr />
        <ActionsButton
          Icon='payments'
          text={`${t('payments')}${user.unpaidInvoicesAmount ? ` (${displayPrice(user.unpaidInvoicesAmount)})` : ''}`}
          action={() => goTo(ACCOUNT_TYPE.payments)} />
        {/* <hr />
        <ActionsButton
          Icon='settings'
          text={t('settings')}
          action={() => goTo(ACCOUNT_TYPE.settings)} /> */}
      </div>
    </div>
  )
}

export default Actions